import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "theme-uitachyons"
    }}>{`@theme-ui/tachyons`}</h1>
    <p>{`Generate static CSS for use outside of React with Theme UI and Tachyons.`}</p>
    <h2 {...{
      "id": "why"
    }}>{`Why?`}</h2>
    <p>{`Though Theme UI comes with its own implementation, project constraints might require
pure utility CSS output. This library allows you to leverage a Theme UI theme that
is used elsewhere and transforms it to the configuration that Tachyons expects. The
best of both worlds.`}</p>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <pre><code parentName="pre" {...{}}>{`yarn add @theme-ui/tachyons
`}</code></pre>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p>{`Transform your Theme UI compliant theme config with the library:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// scripts/generate-tachyons-css.js
const toTachyons = require('@theme-ui/tachyons')
const tachyonsGenerator = require('tachyons-generator')
const theme = require('../theme')

module.exports = async () => {
  const { css } = await tachyonsGenerator(toTachyons(theme)).generate()

  return css
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      